import {
  getWishlist,
  refreshHeaderWishlistCount,
  toggleWishlist,
} from '../utils/wishlist.js';

export const syncWishlistToggleButtons = (root = document) => {
  const handles = getWishlist();

  root.querySelectorAll('[js-wishlist-toggle]').forEach((button) => {
    const handle = button.dataset.productHandle;
    const active = Boolean(handle && handles.includes(handle));

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
};

export default class Wishlist {
  constructor() {
    this.onClick = this.onClick.bind(this);
    this.onUpdated = this.onUpdated.bind(this);

    refreshHeaderWishlistCount();
    syncWishlistToggleButtons();

    document.addEventListener('click', this.onClick);
    document.addEventListener('ird:wishlist:updated', this.onUpdated);
  }

  onClick(event) {
    const toggle = event.target.closest('[js-wishlist-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = toggle.dataset.productHandle;
    if (!handle) return;

    toggleWishlist(handle);
  }

  onUpdated() {
    refreshHeaderWishlistCount();
    syncWishlistToggleButtons();
  }
}
